
const BASE_URL = 'https://api.coinnexs.com/api';

export interface WithdrawalRequestPayload {
    walletId: string;
    amount: string;
    destinationAddress: string;
}

export interface WithdrawalRequestResponse {
    success: boolean;
    data: {
        id: string;
        status: 'PENDING' | 'APPROVED' | 'REJECTED';
        amount: string;
        asset: string;
        requestedAt: string;
    };
}

export interface WithdrawalListEntry {
    id: string;
    oldId: number;
    amount: string;
    asset: string;
    status: 'PENDING' | 'APPROVED' | 'REJECTED';
    destinationAddress: string;
    requestedAt: string;
}

export interface WithdrawalListResponse {
    success: boolean;
    data: WithdrawalListEntry[];
}

class UserWithdrawalService {
    private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
        const token = localStorage.getItem('coinnexs_token');
        const headers: Record<string, string> = {
            ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            'Content-Type': 'application/json',
            ...(options.headers as Record<string, string>),
        };

        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                ...options,
                headers,
            });

            const data = await response.json();
            return data as T;
        } catch (error) {
            console.error(`User Withdrawal API Error (${endpoint}):`, error);
            throw error;
        }
    }

    async createWithdrawal(payload: WithdrawalRequestPayload): Promise<WithdrawalRequestResponse> {
        return this.request<WithdrawalRequestResponse>('/withdrawals', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    }

    async listWithdrawals(params: { page?: number; limit?: number; status?: string } = {}): Promise<WithdrawalListResponse> {
        const query = new URLSearchParams();
        if (params.page) query.append('page', params.page.toString());
        if (params.limit) query.append('limit', params.limit.toString());
        if (params.status) query.append('status', params.status);

        const endpoint = `/withdrawals${query.toString() ? `?${query.toString()}` : ''}`;
        return this.request<WithdrawalListResponse>(endpoint);
    }
}

export const userWithdrawalService = new UserWithdrawalService();
